import { Routes } from "@angular/router";

import { IntroductionScreenComponent } from "./core/components/introduction-screen/introduction-screen.component";
import { AuthCallbackComponent } from "./core/pages/auth-callback/auth-callback.component";
import { IntroductionComponent } from "./core/pages/introduction/introduction.component";
import { AuthGuard } from "./shared/auth/auth.guard";
import { MenuWrapperComponent } from "./shared/route/menu-wrapper/menu-wrapper.component";

export const routes: Routes = [
  //no menu:
  {
    path: "introductie",
    component: IntroductionComponent,
    canActivate: [AuthGuard]
  },
  //  { path: 'auth', component: AuthCallbackComponent },
  {
    path: "",
    component: MenuWrapperComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./core/core.routes").then((m) => m.CoreRoutes)
      },
      {
        path: "aan-de-slag",
        loadChildren: () =>
          import("./tools/tools.routes").then((m) => m.ToolsRoutes),
        data: { breadcrumb: "Aan de slag!" }
      },
      {
        path: "advies",
        loadChildren: () =>
          import("./advice/advice.routes").then((m) => m.AdviceRoutes)
      },
      {
        path: "activiteiten",
        loadChildren: () =>
          import("./activities/activities.routes").then(
            (m) => m.ActivitiesRoutes
          )
      },
      {
        path: "vitaliteit",
        loadChildren: () =>
          import("./health/health.routes").then((m) => m.HealthRoutes)
      },
      {
        path: "echeq/detail/:vcheqId",
        redirectTo: "/activiteiten/detail/:vcheqId",
        pathMatch: "full"
      },
      {
        path: "vcheq/detail/:vcheqId",
        redirectTo: "/activiteiten/detail/:vcheqId",
        pathMatch: "full"
      },
      {
        path: "vcheq/nieuw/:vcheqFamilyId",
        redirectTo: "/activiteiten/nieuw/:vcheqFamilyId",
        pathMatch: "full"
      },

      {
        path: "q/:questionnaireId",
        redirectTo: "/questionnaire/:questionnaireId",
        pathMatch: "full"
      },
      {
        path: "questionnaire/:questionnaireId",
        loadChildren: () =>
          import("./questionnaire/questionnaire.routes").then(
            (m) => m.QuestionnaireRoutes
          )
      }
      // {
      //   path: 'help',
      //   component: HelpPageComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'trainingen',
      //   component: TrainingComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'trainingen/:training',
      //   component: TrainingDetailComponent,
      //   canActivate: [AuthGuard],
      // },
    ]
  },
  { path: "auth", component: IntroductionScreenComponent },
  {
    path: "vcheq/detail/:vcheqId",
    redirectTo: "/activiteiten/detail/:vcheqId",
    pathMatch: "full"
  },
  {
    path: "vcheq/nieuw/:vcheqFamilyId",
    redirectTo: "/activiteiten/nieuw/:vcheqFamilyId",
    pathMatch: "full"
  },
  // {
  //   path: 'help',
  //   component: HelpPageComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'trainingen',
  //   component: TrainingComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'trainingen/:training',
  //   component: TrainingDetailComponent,
  //   canActivate: [AuthGuard],
  // },
  { path: "*", component: AuthCallbackComponent }
];
